exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divFilterSDocDesc[data-v-01774fa9]{position:absolute;background-color:#fee3e8;min-height:80px;max-height:170px;z-index:99999;padding:5px;border-radius:5px;box-shadow:0 0 5px rgb(0 0 0/40%)}.divFilterSDocDesc table[data-v-01774fa9]{background-color:#fff}.selRow[data-v-01774fa9]{background-color:#fbff94}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-01774fa9","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/AdminPanel/Components/NewAccDoc/Components/FilterSAccDesc.vue
// module id = 525
// module chunks = 0